/**
 * Stockage local du poste (IndexedDB) pour le mode hors connexion.
 *  - « kv »   : données de référence et dernières copies d'écrans ;
 *  - « file » : saisies faites sans connexion, en attente d'envoi.
 * Les données de référence sont effacées à la déconnexion.
 */
const NOM = 'clinique-hors-ligne'
const VERSION = 1
let ouverture = null

function ouvrir() {
  if (!('indexedDB' in window)) return Promise.reject(new Error('Stockage local indisponible'))
  if (!ouverture) {
    ouverture = new Promise((resolve, reject) => {
      const req = indexedDB.open(NOM, VERSION)
      req.onupgradeneeded = () => {
        const db = req.result
        if (!db.objectStoreNames.contains('kv')) db.createObjectStore('kv')
        if (!db.objectStoreNames.contains('file')) db.createObjectStore('file', { keyPath: 'id' })
      }
      req.onsuccess = () => resolve(req.result)
      req.onerror = () => { ouverture = null; reject(req.error) }
    })
  }
  return ouverture
}

async function transaction(store, mode, action) {
  const db = await ouvrir()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(store, mode)
    const req = action(tx.objectStore(store))
    tx.oncomplete = () => resolve(req ? req.result : undefined)
    tx.onerror = () => reject(tx.error)
    tx.onabort = () => reject(tx.error)
  })
}

export const kv = {
  lire: (cle) => transaction('kv', 'readonly', s => s.get(cle)).catch(() => undefined),
  ecrire: (cle, valeur) => transaction('kv', 'readwrite', s => s.put(valeur, cle)).catch(() => undefined),
  supprimer: (cle) => transaction('kv', 'readwrite', s => s.delete(cle)).catch(() => undefined),
  vider: () => transaction('kv', 'readwrite', s => s.clear()).catch(() => undefined),
}

export const file = {
  liste: () => transaction('file', 'readonly', s => s.getAll()).then(l => (l || []).sort((a, b) => a.ordre - b.ordre)).catch(() => []),
  enregistrer: (item) => transaction('file', 'readwrite', s => s.put(JSON.parse(JSON.stringify(item)))),
  supprimer: (id) => transaction('file', 'readwrite', s => s.delete(id)),
}
